import { render, staticRenderFns } from "./MediacontactPartnerCategoryEdit.vue?vue&type=template&id=13dbe0f2"
import script from "./MediacontactPartnerCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports